import React from 'react';
import CurrencyInput from 'react-currency-input-field';
import InputMask from 'react-input-mask';
import moment from 'moment';

import { 
    Row,
    Col,
    Form,
} from "react-bootstrap-v5";

import Utils from '../../../../utils/utils';

import RSuiteDatePicker from '../../../../components/OLD/Datepicker/RSuiteDatePicker';

import { fields, hasSpecialDate, getDayOfWeekLabel } from '../redux/payrollBetaForm';

import { useFormikContext } from '../PayrollBetaForm';

import { StyledColLeft, StyledColRight, StyledPay, StyledDatePicker, StyledFormLabel, StyledFormText } from '../style/styles';


const WorkTime = (props: any) => {
    const { values, errors, setFieldValue } = useFormikContext();


    const workTimeForm = () => {
        return <Row>
            <Col xs={12} className={'mb-3'}>
                <Row>
                    <Col xs={2} md={2} lg={2} xl={1}>
                        <div className={'position-absolute'}><StyledFormLabel>WORK DAYS</StyledFormLabel></div>
                    </Col>
                    <Col xs={12} md={10} lg={10} xl={8}>
                        <Row className={'align-items-center mb-2'}>
                            <Col xs={12} md={6}>&nbsp;</Col>
                            <Col xs={12} md={6} className={'d-none d-md-block'}><StyledPay>Pay</StyledPay></Col>
                        </Row>
                    </Col>
                </Row>
            </Col>
            <Col xs={12}>
                {(values.selectedWorkTime && values.selectedWorkTime.workingDays && values.selectedWorkTime.workingDays.length > 0) && <>
                    {values.selectedWorkTime.workingDays.map((item: any, i: number) => {
                        if(item.isEnabled){
                            return <Row key={'workTimes_' + i} className={'mb-3'}>
                                <Col xs={2} md={2} lg={2} xl={1} className={'mt-0 mt-md-3 mb-2 mb-md-0'}><StyledFormText>{getDayOfWeekLabel(item.day)}</StyledFormText></Col>
                                <Col xs={12} md={10} lg={10} xl={8}>
                                    {item.times.map((subItem: any, j: number) => {
                                        return <Row key={'work_times_' + i + '_day_' + j} className={'align-items-center mb-2'}>
                                            <Col xs={12} md={6} className={'mb-3 mb-md-0'}>
                                                <Row className={'align-items-center'}>
                                                    <Col xs={12} sm={true} className={'custom-rsuite-time-picker-component'}>
                                                        <Form.Control
                                                            as = {InputMask}
                                                            mask={'99:99'}
                                                            size={'sm'}
                                                            readOnly={true}
                                                            tabIndex={-1}

                                                            id={fields.workTimes.id + '_' + i + '_' + fields.workTimesTimeFrom.id + '_' + j + '_timeFrom'}
                                                            isInvalid={!!(errors.selectedWorkTime && errors.selectedWorkTime.workingDays && errors.selectedWorkTime.workingDays[i] && errors.selectedWorkTime.workingDays[i].times && errors.selectedWorkTime.workingDays[i].times[j] && errors.selectedWorkTime.workingDays[i].times[j].timeFrom)}
                                                            placeholder={fields.workTimesTimeFrom.placeholder}
                                                            value={subItem.timeFrom}
                                                            onChange={(e: any) => {
                                                                setFieldValue('selectedWorkTime.workingDays.' + i + '.times.' + j + '.timeFrom', e.target.value);
                                                            }}
                                                        />
                                                    </Col>
                                                    <Col xs={'auto'} className={'d-none d-lg-block px-1'}><StyledFormText>TO</StyledFormText></Col>
                                                    <Col xs={12} sm={true} className={'custom-rsuite-time-picker-component'}>
                                                        <Form.Control
                                                            as = {InputMask}
                                                            mask={'99:99'}
                                                            size={'sm'}
                                                            readOnly={true}
                                                            tabIndex={-1}

                                                            id={fields.workTimes.id + '_' + i + '_' + fields.workTimesTimeTo.id + '_' + j + '_timeTo'}
                                                            isInvalid={!!(errors.selectedWorkTime && errors.selectedWorkTime.workingDays && errors.selectedWorkTime.workingDays[i] && errors.selectedWorkTime.workingDays[i].times && errors.selectedWorkTime.workingDays[i].times[j] && errors.selectedWorkTime.workingDays[i].times[j].timeTo)}
                                                            placeholder={fields.workTimesTimeTo.placeholder}
                                                            value={subItem.timeTo}
                                                            onChange={(e: any) => {
                                                                setFieldValue('selectedWorkTime.workingDays.' + i + '.times.' + j + '.timeTo', e.target.value);
                                                            }}
                                                        />
                                                    </Col>
                                                </Row>
                                            </Col>
                                            <Col xs={12} md={6}>
                                                <StyledFormLabel className={'d-block d-md-none'}><StyledPay>{fields.workTimesPay.label}</StyledPay></StyledFormLabel>
                                                <Form.Control
                                                    as = {CurrencyInput}
                                                    allowDecimals={true}
                                                    allowNegativeValue={false}
                                                    disableGroupSeparators={true}
                                                    prefix={Utils.getCurrency()}
                                                    size={'sm'}
                                                    tabIndex={i*j}
                                                    style={{ borderColor: (errors.selectedWorkTime && errors.selectedWorkTime.workingDays && errors.selectedWorkTime.workingDays[i] && errors.selectedWorkTime.workingDays[i].times && errors.selectedWorkTime.workingDays[i].times[j] && errors.selectedWorkTime.workingDays[i].times[j].standardPay) ? '#FF0090' : '#0066FF' }}

                                                    id={fields.workTimes.id + '_' + i + '_' + fields.workTimesPay.id + '_' + j + '_pay'}
                                                    isInvalid={!!(errors.selectedWorkTime && errors.selectedWorkTime.workingDays && errors.selectedWorkTime.workingDays[i] && errors.selectedWorkTime.workingDays[i].times && errors.selectedWorkTime.workingDays[i].times[j] && errors.selectedWorkTime.workingDays[i].times[j].standardPay)}
                                                    placeholder={fields.workTimesPay.placeholder}
                                                    value={subItem.standardPay}
                                                    onValueChange={(value: any) => {
                                                        setFieldValue('selectedWorkTime.workingDays.' + i + '.times.' + j + '.standardPay', value);
                                                    }}
                                                />
                                            </Col>
                                        </Row>
                                    })}
                                </Col>
                            </Row>
                        }
                    })}
                </>}
            </Col>
        </Row>
    }

    const specialDatesForm = () => {
        return <Row>
            <Col xs={12} className={'mb-3'}>
                <Row>
                    <Col xs={12} md={4} lg={4} xl={4}>
                        <div className={'position-absolute'}><StyledFormLabel>SPECIAL DATES</StyledFormLabel></div>
                    </Col>
                    <Col xs={12} md={8} lg={8} xl={8}>
                        <Row className={'align-items-center mb-2'}>
                            <Col xs={12} md={8}>&nbsp;</Col>
                            <Col xs={12} md={4} className={'d-none d-md-block'}><StyledPay>Pay</StyledPay></Col>
                        </Row>
                    </Col>
                </Row>
            </Col>
            <Col xs={12}>
                {(values.selectedWorkTime && values.selectedWorkTime.specialDays && values.selectedWorkTime.specialDays.length > 0) && <>
                    {values.selectedWorkTime.specialDays.map((item: any, i: number) => {
                        return <Row key={'specialDays_' + i} className={'mb-3'}>
                            <Col xs={12} md={4} lg={4} xl={4}>
                                <StyledDatePicker
                                    as = {RSuiteDatePicker}
                                    isInvalid={!!(errors.specialDays && errors.specialDays.length > 0 && errors.specialDays[i] && errors.specialDays[i].date)}
                                    className={'form-control'}
                                    tabIndex={1000+i}
                                    
                                    placeholder={fields.specialDatesDate.placeholder}
                                    id={fields.specialDates.id + '_' + i + '_date'}
                                    value={item.date}
                                    icon={<></>}
                                    placement={'bottomStart'}
                                    cleanable={true}
                                    isDefault={true}
                                    readOnly={true}
                                    oneTap={true}
                                    // disabledDate={(date: any) => {
                                    //     return (moment(date).isAfter(moment().subtract(1, 'days'))) ? false : true;
                                    // }}
                                    onChange={(value: any) => {
                                        setFieldValue('selectedWorkTime.specialDays.' + i + '.date', value);
                                    }}
                                />
                            </Col>
                            <Col xs={12} md={8} lg={8} xl={8}>
                                {item.times.map((subItem: any, j: number) => {
                                    return <Row key={'special_Dates_' + i + '_day_' + j} className={'align-items-center mb-2'}>
                                        <Col xs={12} md={8} className={'mb-3 mb-md-0'}>
                                            <Row className={'align-items-center'}>
                                                <Col xs={12} sm={true} className={'custom-rsuite-time-picker-component'}>
                                                    <Form.Control
                                                        as = {InputMask}
                                                        mask={'99:99'}
                                                        size={'sm'}
                                                        readOnly={true}
                                                        tabIndex={-1}

                                                        id={fields.workTimes.id + '_' + i + '_' + fields.workTimesTimeFrom.id + '_' + j + '_timeFrom'}
                                                        isInvalid={!!(errors.selectedWorkTime && errors.selectedWorkTime.specialDays && errors.selectedWorkTime.specialDays[i] && errors.selectedWorkTime.specialDays[i].times && errors.selectedWorkTime.specialDays[i].times[j] && errors.selectedWorkTime.specialDays[i].times[j].timeFrom)}
                                                        placeholder={fields.workTimesTimeFrom.placeholder}
                                                        value={subItem.timeFrom}
                                                        onChange={(e: any) => {
                                                            setFieldValue('selectedWorkTime.specialDays.' + i + '.times.' + j + '.timeFrom', e.target.value);
                                                        }}
                                                    />
                                                </Col>
                                                <Col xs={'auto'} className={'d-none d-lg-block px-1'}><StyledFormText>TO</StyledFormText></Col>
                                                <Col xs={12} sm={true} className={'custom-rsuite-time-picker-component'}>
                                                    <Form.Control
                                                        as = {InputMask}
                                                        mask={'99:99'}
                                                        size={'sm'}
                                                        readOnly={true}
                                                        tabIndex={-1}

                                                        id={fields.workTimes.id + '_' + i + '_' + fields.workTimesTimeTo.id + '_' + j + '_timeTo'}
                                                        isInvalid={!!(errors.selectedWorkTime && errors.selectedWorkTime.specialDays && errors.selectedWorkTime.specialDays[i] && errors.selectedWorkTime.specialDays[i].times && errors.selectedWorkTime.specialDays[i].times[j] && errors.selectedWorkTime.specialDays[i].times[j].timeTo)}
                                                        placeholder={fields.workTimesTimeTo.placeholder}
                                                        value={subItem.timeTo}
                                                        onChange={(e: any) => {
                                                            setFieldValue('selectedWorkTime.specialDays.' + i + '.times.' + j + '.timeTo', e.target.value);
                                                        }}
                                                    />
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col xs={12} md={4}>
                                            <StyledFormLabel className={'d-block d-md-none'}><StyledPay>{fields.workTimesPay.label}</StyledPay></StyledFormLabel>
                                            <Form.Control
                                                as = {CurrencyInput}
                                                allowDecimals={true}
                                                allowNegativeValue={false}
                                                disableGroupSeparators={true}
                                                prefix={Utils.getCurrency()}
                                                size={'sm'}
                                                tabIndex={i*j}
                                                style={{ borderColor: (errors.selectedWorkTime && errors.selectedWorkTime.specialDays && errors.selectedWorkTime.specialDays[i] && errors.selectedWorkTime.specialDays[i].times && errors.selectedWorkTime.specialDays[i].times[j] && errors.selectedWorkTime.specialDays[i].times[j].standardPay) ? '#FF0090' : '#0066FF' }}

                                                id={fields.workTimes.id + '_' + i + '_' + fields.workTimesPay.id + '_' + j + '_pay'}
                                                isInvalid={!!(errors.selectedWorkTime && errors.selectedWorkTime.specialDays && errors.selectedWorkTime.specialDays[i] && errors.selectedWorkTime.specialDays[i].times && errors.selectedWorkTime.specialDays[i].times[j] && errors.selectedWorkTime.specialDays[i].times[j].standardPay)}
                                                placeholder={fields.workTimesPay.placeholder}
                                                value={subItem.standardPay}
                                                onValueChange={(value: any) => {
                                                    setFieldValue('selectedWorkTime.specialDays.' + i + '.times.' + j + '.standardPay', value);
                                                }}
                                            />
                                        </Col>
                                    </Row>
                                })}
                            </Col>
                        </Row>
                    })}
                </>}
            </Col>
        </Row>
    }


    return <Row>
        <Col xs={12} xl={{ span: 10, offset: 1 }}>
            <Row className={'justify-content-center'} style={{ border: '1px solid #ececec', borderBottom: '0px' }}>
                <Col xs={12} lg={6} xl={6} className={'py-5 ps-5'}><h3 className={'m-0'}>Work Time</h3></Col>
                <Col xs={12} lg={6} xl={6}></Col>
            </Row>
            <Row className={'justify-content-center'} style={{ border: '1px solid #ececec' }}>
                <StyledColLeft xs={12} lg={6} xl={6} hasspecialdate={values.hasSpecialDates}>{workTimeForm()}</StyledColLeft>
                {values.hasSpecialDates && <StyledColRight xs={12} lg={6} xl={6}>{specialDatesForm()}</StyledColRight>}
            </Row>
        </Col>
    </Row>
}


export default WorkTime;
